import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import AdminSettingsComponent from '../components/admin/Settings';

interface User {
  id: string;
  email: string;
  isAdmin: boolean;
  approved: boolean;
  createdAt: string;
  updatedAt: string;
}

const AdminSettings: React.FC = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userStr = localStorage.getItem('user');

    if (!token || !userStr) {
      navigate('/admin/login');
      return;
    }

    try {
      const userData = JSON.parse(userStr);
      if (!userData.isAdmin) {
        navigate('/admin/login');
        return;
      }
      setUser(userData);
    } catch (err) {
      navigate('/admin/login');
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/admin/login');
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-main-dark flex items-center justify-center">
        <div className="text-gray-400 text-lg">Loading...</div>
      </div>
    );
  }

  return (
    <div className="w-full min-h-screen bg-main-dark flex flex-col">
      <Header
        title="Admin Settings"
        subtitle={user ? `Welcome, ${user.email}` : undefined}
        onLogout={handleLogout}
        onSettingsClick={() => navigate('/admin/dashboard')}
      />
      <AdminSettingsComponent userId={user?.id} />
      <Footer />
    </div>
  );
};

export default AdminSettings;
